module.exports = __webpack_public_path__ + "img/Technology Partner-4.245a1d82.png";